import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_SEARCH_PHARMACY_MEDICINES_FOR_DOCTOR } from "../../action-types/actions";

import i18n from "../../i18n";
export const searchPharmacyMedicinesForDoctor = createAsyncThunk(
  ACTIONS_SEARCH_PHARMACY_MEDICINES_FOR_DOCTOR.search_medicines_for_doctor,
  async (
    { category_id, query = "", page = 1, limit = 20 },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      if (!query || query.trim() === "") {
        return rejectWithValue(i18n.t("toast.searchQueryIsRequired"));
      }

      const queryParams = new URLSearchParams({
        query: query.trim(),
        page: page.toString(),
        limit: limit.toString(),
      });

      // Only add category_id if provided and valid
      if (category_id && category_id > 0) {
        queryParams.append("category_id", category_id.toString());
      }

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.searchPharmacyMedicinesForDoctor}?${queryParams.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("toast.failedToSearchMedicines"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorSearchingMedicines");
      // Don't show toast for validation errors
      if (error?.response?.status !== 400) {
        toast.error(errMsg);
      }
      return rejectWithValue(errMsg);
    }
  },
);
